export default __webpack_public_path__ + "static/media/Bitmap_4.04e36fb7.jpg";